import React, { useState } from 'react';
import './CreateUserModal.css';
import { PASSWORD_HELP_TEXT, validatePassword } from '../utils/passwordPolicy';
import { USERNAME_HELP_TEXT, validateUsername } from '../utils/usernamePolicy';
import { validateEmail } from '../utils/emailPolicy';

function CreateUserModal({ onClose, onCreateUser }) {
  const [userData, setUserData] = useState({
    username: '',
    email: '',
    password: '',
    name: '',
    birth_date: '',
    gender: '',
    phone: '',
    admin: false,
    verified: false,
    banned: false
  });
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (userData.password !== confirmPassword) {
      setPasswordError('Lozinke se ne podudaraju.');
      return;
    }
    const usernamePolicyError = validateUsername(userData.username);
    if (usernamePolicyError) {
      setPasswordError(usernamePolicyError);
      return;
    }
    const emailPolicyError = validateEmail(userData.email);
    if (emailPolicyError) {
      setPasswordError(emailPolicyError);
      return;
    }
    const passwordPolicyError = validatePassword(userData.password, {
      username: userData.username,
      email: userData.email,
    });
    if (passwordPolicyError) {
      setPasswordError(passwordPolicyError);
      return;
    }
    setPasswordError('');
    onCreateUser(userData);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Napravi novog korisnika</h3>
        <form onSubmit={handleSubmit} noValidate>
          <div className="form-group">
            <label>Korisničko ime:</label>
            <input
              type="text"
              required
              title={USERNAME_HELP_TEXT}
              autoComplete="username"
              value={userData.username}
              onChange={(e) => setUserData({...userData, username: e.target.value})}
            />
            <small className="password-help">{USERNAME_HELP_TEXT}</small>
          </div>
          <div className="form-group">
            <label>Email:</label>
            <input
              type="email"
              required
              value={userData.email}
              onChange={(e) => setUserData({...userData, email: e.target.value})}
            />
          </div>
          <div className="form-group">
            <label>Lozinka:</label>
            <div className="password-input-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                required
                autoComplete="new-password"
                value={userData.password}
                onChange={(e) => setUserData({...userData, password: e.target.value})}
              />
              <button
                type="button"
                className="password-toggle-btn"
                onClick={() => setShowPassword(!showPassword)}
                tabIndex={-1}
              >
                {showPassword ? (
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                    <line x1="1" y1="1" x2="23" y2="23"/>
                  </svg>
                ) : (
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                )}
              </button>
            </div>
            <small className="password-help">{PASSWORD_HELP_TEXT}</small>
          </div>
          <div className="form-group">
            <label>Potvrda lozinke:</label>
            <div className="password-input-wrapper">
              <input
                type={showConfirmPassword ? "text" : "password"}
                required
                autoComplete="new-password"
                value={confirmPassword}
                onChange={(e) => { setConfirmPassword(e.target.value); setPasswordError(''); }}
              />
              <button
                type="button"
                className="password-toggle-btn"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                tabIndex={-1}
              >
                {showConfirmPassword ? (
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                    <line x1="1" y1="1" x2="23" y2="23"/>
                  </svg>
                ) : (
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                )}
              </button>
            </div>
            {passwordError && <p className="password-error">{passwordError}</p>}
          </div>
          <div className="form-group">
            <label>Ime:</label>
            <input
              type="text"
              value={userData.name}
              onChange={(e) => setUserData({...userData, name: e.target.value})}
            />
          </div>
          <div className="form-group">
            <label>Datum rođenja:</label>
            <input
              type="date"
              value={userData.birth_date}
              onChange={(e) => setUserData({...userData, birth_date: e.target.value})}
            />
          </div>
          <div className="form-group">
            <label>Spol:</label>
            <select
              value={userData.gender}
              onChange={(e) => setUserData({...userData, gender: e.target.value})}
            >
              <option value="">Nije odabrano</option>
              <option value="M">Muško</option>
              <option value="F">Žensko</option>
              <option value="O">Ostalo</option>
            </select>
          </div>
          <div className="form-group">
            <label>Telefon:</label>
            <input
              type="tel"
              value={userData.phone}
              onChange={(e) => setUserData({...userData, phone: e.target.value})}
            />
          </div>
          <div className="form-group checkbox-group">
            <label>
              <input
                type="checkbox"
                checked={userData.admin}
                onChange={(e) => setUserData({...userData, admin: e.target.checked})}
              />
              Admin
            </label>
          </div>
          <div className="form-group checkbox-group">
            <label>
              <input
                type="checkbox"
                checked={userData.verified}
                onChange={(e) => setUserData({...userData, verified: e.target.checked})}
              />
              Verifikovan
            </label>
          </div>
          <div className="form-group checkbox-group">
            <label>
              <input
                type="checkbox"
                checked={userData.banned}
                onChange={(e) => setUserData({...userData, banned: e.target.checked})}
              />
              Banovan
            </label>
          </div>
          <div className="modal-actions">
            <button type="submit" className="save-btn">Spremi</button>
            <button type="button" className="cancel-btn" onClick={onClose}>Odustani</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateUserModal;
